import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  currentRoute: string;
  year: any;

  constructor(
    public configService: ConfigService,
    private router: Router
  ) { 
    var now = new Date();
    this.year = now.getFullYear();
    this.currentRoute = this.router.url.replace(/\//g, '');
  }

  ngOnInit() {}

}
